/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './exception-photos.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../small-spinner/small-spinner.component.ngfactory';
import * as i3 from '../../../../../../app/modules/utilities/components/small-spinner/small-spinner.component';
import * as i4 from '../exception-image/exception-image.component.ngfactory';
import * as i5 from '../../../../../../app/modules/utilities/components/exception-image/exception-image.component';
import * as i6 from '@angular/common';
import * as i7 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i8 from '@angular/material';
import * as i9 from '@angular/cdk/platform';
import * as i10 from '../../../../../../app/modules/utilities/components/exception-photos/exception-photos.component';
import * as i11 from '../../../../../../app/modules/utilities/services/exception-photos/exception-photos.service';
import * as i12 from '../../../../../../app/modules/form-renderer/services/flight-field-group/flight-field-group.service';
import * as i13 from '../../../../../../app/modules/utilities/FormUtilities';
const styles_ExceptionPhotosComponent:any[] = [i0.styles];
export const RenderType_ExceptionPhotosComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ExceptionPhotosComponent,data:{}});
function View_ExceptionPhotosComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-small-spinner',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_SmallSpinnerComponent_0,
      i2.RenderType_SmallSpinnerComponent)),i1.ɵdid(1,114688,(null as any),0,i3.SmallSpinnerComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
function View_ExceptionPhotosComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-exception-image',
      ([] as any[]),(null as any),[[(null as any),'select'],[(null as any),'clear']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('select' === en)) {
          const pd_0:any = ((<any>_co.clickImage($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('clear' === en)) {
          const pd_1:any = ((<any>_co.deleteImage($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i4.View_ExceptionImageComponent_0,i4.RenderType_ExceptionImageComponent)),
      i1.ɵdid(1,49152,(null as any),0,i5.ExceptionImageComponent,([] as any[]),{image:[0,
          'image']},{clear:'clear',select:'select'})],(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
function View_ExceptionPhotosComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ExceptionPhotosComponent_4)),i1.ɵdid(3,
          16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],
      (_ck,_v) => {
        const currVal_0:boolean = !_v.context.$implicit.delete;
        _ck(_v,3,0,currVal_0);
      },(null as any));
}
function View_ExceptionPhotosComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      4,'button',[['class','mat-raised-button'],['color','accent'],['md-raised-button',
          ''],['type','button']],[[8,'disabled',0]],[[(null as any),'click']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.uploadPhoto()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i7.View_MdButton_0,i7.RenderType_MdButton)),i1.ɵdid(3,16384,(null as any),
      0,i8.MdPrefixRejector,[[2,i8.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(4,180224,(null as any),0,i8.MdButton,[i1.Renderer2,i1.ElementRef,
      i9.Platform,i8.FocusOriginMonitor],{color:[0,'color']},(null as any)),i1.ɵdid(5,
      16384,(null as any),0,i8.MdRaisedButtonCssMatStyler,([] as any[]),(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,0,['Add Image'])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  ']))],(_ck,_v) => {
    const currVal_1:any = 'accent';
    _ck(_v,4,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,4).disabled || (null as any));
    _ck(_v,2,0,currVal_0);
  });
}
function View_ExceptionPhotosComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'imageContainer']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ExceptionPhotosComponent_3)),i1.ɵdid(3,
          802816,(null as any),0,i6.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ExceptionPhotosComponent_5)),i1.ɵdid(6,16384,(null as any),0,i6.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.imageList;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = (_co.amountOfImages < 4);
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
export function View_ExceptionPhotosComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{fileInput:0}),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),4,'div',[['class','spinnerContainer']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_ExceptionPhotosComponent_1)),i1.ɵdid(4,16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_ExceptionPhotosComponent_2)),
      i1.ɵdid(8,16384,(null as any),0,i6.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n']))],
      (_ck,_v) => {
        var _co:i10.ExceptionPhotosComponent = _v.component;
        const currVal_0:any = _co.showLoading;
        _ck(_v,4,0,currVal_0);
        const currVal_1:boolean = !_co.showLoading;
        _ck(_v,8,0,currVal_1);
      },(null as any));
}
export function View_ExceptionPhotosComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-exception-photos',
      ([] as any[]),(null as any),(null as any),(null as any),View_ExceptionPhotosComponent_0,
      RenderType_ExceptionPhotosComponent)),i1.ɵdid(1,114688,(null as any),0,i10.ExceptionPhotosComponent,
      [i11.ExceptionPhotosService,i12.FlightFieldGroupService,i13.FormUtilities,i8.MdSnackBar],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ExceptionPhotosComponentNgFactory:i1.ComponentFactory<i10.ExceptionPhotosComponent> = i1.ɵccf('app-exception-photos',
    i10.ExceptionPhotosComponent,View_ExceptionPhotosComponent_Host_0,{serviceId:'serviceId'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/utilities/components/exception-photos/exception-photos.component.ngfactory.ts